import React from 'react';
import CreditCardForm from '../../components/CreditCardForm';

const QuickBooksPayment = () => {
  return (
    <div>
      <CreditCardForm />
    </div>
  );
};

export default QuickBooksPayment;
